import { z } from 'zod';
import { refersTo } from '../common/refers-to';
import { ValuationSourceSchema } from './valuation-agent-result.schemas';

export const OBJECT_VALUE_CURRENCY = 'EUR' as const;

export const ObjectValueSchema = z.discriminatedUnion('source', [
  z.object({
    source: z.literal('OWN_VALUATION'),
    from: z.number(),
    to: z.number(),
    asOf: z.iso.date(),
    // Not `source`: that is this union's discriminator.
    valuationSource: ValuationSourceSchema,
  }),
  z.object({
    source: z.literal('LEAD_ESTIMATE'),
    amount: z.number(),
    asOf: z.iso.date(),
  }),
]);

export const ObjectValueResponseSchema = z.object({
  object: z.object({
    propertyId: refersTo('property', z.string()),
    organizationId: refersTo('organization', z.string()),
    formattedAddress: z.string().nullable(),
  }),
  currency: z.literal(OBJECT_VALUE_CURRENCY),
  value: ObjectValueSchema.nullable(),
  unreleasedValuation: z.boolean(),
});

export type ObjectValueResponse = z.infer<typeof ObjectValueResponseSchema>;
